import { EarningMechanism } from '@occc/graphql';

export const supportedEarningMechanisms: EarningMechanism['__typename'][] = [
  'EarningMechanismTotalEligiblePurchaseOverTime',
  'EarningMechanismVarietyPurchaseOverTime',
  'EarningMechanismTotalSpendOverTime',
];
